module.exports = __webpack_public_path__ + "img/center.0fd749cd.png";